import './ExplorersJournalRow.styles.scss';
import { ExplorersJournalRowProps } from './ExplorersJournalRow.types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useEffect, useState } from 'react';
import { BASE_SANITY_IMAGE_URL } from '../../../../configs/constants';
import { Link } from 'react-router-dom';

function ExplorersJournalRow({ city, journalSummary, sanityImageUrl, type = 'city-guide', title, url, slug }: ExplorersJournalRowProps) {
  const [img, setImg] = useState('');

  useEffect(() => {
    if (sanityImageUrl) {
      setImg(sanityImageUrl.split('image-')[1].replace('-jpg', '.jpg'));
    }
  }, [sanityImageUrl]);

  return (
    <div className="explorer-journal-row">
      <div className="col-12 flex explorer-journal-container px-0 px-sm-3">
        <div className="col-12 col-sm-5 col-lg-4 explorer-journal-image-container">
          <LazyLoadImage src={`${BASE_SANITY_IMAGE_URL}${img}`} alt={city} className="explorer-journal-image" />
        </div>
        <div className="col-12 col-sm-7 col-lg-8 explorer-journal-row-right-container">
          <div className="explorer-journal-row-right-first-row">
            <p className="explorer-journal-row-type">{type}</p>
            <p className="explorer-journal-row-type">{city}</p>
          </div>
          <h3 className="explorer-journal-row-title">
            <Link to={`${url}/${slug}`}>{title}</Link>
          </h3>
          <p className="explorer-journal-row-summary">{journalSummary}</p>
          <div className="explorer-journal-row-read-more">
            <Link to={`${url}/${slug}`}>Read More</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExplorersJournalRow;
